import { Box, BoxProps, createUseVariantStyle, forwardRef } from '@bonusly/design-system';

import { DropdownVariant } from './types';

interface Props extends BoxProps {
	role?: string;
	variant?: DropdownVariant;
}

const useVariantStyle = createUseVariantStyle({
	variant: {
		floating: {
			borderRadius: 'md',
			_focus: { backgroundColor: 'gray.25' },
			_hover: { backgroundColor: 'gray.25' },
		},
		staticControlledHighlight: {
			backgroundColor: 'gray.50',
		},
	},
});

const defaultStyles = {
	backgroundColor: 'white',
	border: 0,
	borderColor: 'gray.50',
	borderRadius: 'sm',
	borderStyle: 'solid',
	cursor: 'pointer',
	listStyleType: 'none',
	p: 2,
	transitionDuration: 'normal',
	transitionProperty: 'common',
	_focus: { backgroundColor: 'gray.25' },
	_hover: { backgroundColor: 'gray.50' },
};

export const DropdownOption = forwardRef(({ variant, ...rest }: Props, ref) => {
	return <Box as="li" role="option" tabIndex={0} ref={ref} {...defaultStyles} {...useVariantStyle({ variant })} {...rest} />;
});

export type { Props as DropdownOptionProps };
